// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input-md {
  margin: 8px 0px;
  padding: 0;
  width: 100%;
}

.ion-text-center {
  display: flex;
  justify-content: center;
}

h5 {
  padding-top: 15px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,4BAAA;AACF","sourcesContent":[".text-input-md {\n  margin: 8px 0px;\n  padding: 0;\n  width: 100%;\n}\n\n.ion-text-center {\n  display: flex;\n  justify-content: center;\n}\n\nh5 {\n  padding-top: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
